export function antDecorator(Vue) {
  return Vue.directive('decorator', {});
}

export default {
  // just for tag
  install: function install(Vue) {
    antDecorator(Vue);
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/_util/FormDecoratorDirective.js
// module id = 188
// module chunks = 0